module.exports = __webpack_public_path__ + "assets/img/1.dfc2ac26.png";